module.exports = __webpack_public_path__ + "static/media/2.d1fb5136.jpg";